export default {
    FETCHED_PURCHASE_ORDER: 'FETCHED_PURCHASE_ORDER',
    ADD_PURCHASE_ORDER: 'ADD_PURCHASE_ORDER',
    FETCHED_MERCHANT_PURCHASE_ORDER: 'FETCHED_MERCHANT_PURCHASE_ORDER',
    FETCHED_PURCHASE_ORDER_DETAILS: 'FETCHED_PURCHASE_ORDER_DETAILS',
    FETCHED_PURCHASE_ORDER_INVOICES_DETAILS: 'FETCHED_PURCHASE_ORDER_INVOICES_DETAILS'
}
